// extracted by mini-css-extract-plugin
export default {"list":"paymentLink_list__mbWGG","linkWrapper":"paymentLink_linkWrapper__M1WaA","tooltip":"paymentLink_tooltip__QA4c0","listValue":"paymentLink_listValue__OtSlw"};